import React from 'react'
import { Button, CircularProgress, Grid, Popover, Typography } from '@material-ui/core'
import { ReactSelectOption } from '../../../../types'

interface MigrationActionsProps {
  isExporting: boolean
  isRefreshing: boolean
  isImporting: boolean
  isLoading: boolean
  noShopCheckboxEnabled: boolean
  selectedCompany: ReactSelectOption | undefined
  isGettingDetails: boolean
  glCompanyId: number | undefined
  isExportDisabled: boolean
  onExport: () => void
  onRefresh: () => void
  openImportModal: () => void
  onPopoverOpen: (event: React.MouseEvent<HTMLElement>) => void
  onPopoverClose: () => void
  anchorEl: HTMLElement | null
}

export const MigrationActions: React.FC<MigrationActionsProps> = ({
  isExporting,
  isRefreshing,
  isImporting,
  isLoading,
  noShopCheckboxEnabled,
  selectedCompany,
  isGettingDetails,
  glCompanyId,
  isExportDisabled,
  onExport,
  onRefresh,
  openImportModal,
  onPopoverOpen,
  onPopoverClose,
  anchorEl,
}) => {
  const open = Boolean(anchorEl)
  return (
    <Grid container item>
      <Grid item xs={4}>
        <Button className={'primary-button margin'} onClick={onExport} disabled={isExportDisabled}>
          {isExporting ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Export'}
        </Button>
      </Grid>
      <Grid item xs={4}>
        <Button
          disabled={isRefreshing || isGettingDetails || !selectedCompany}
          className={'primary-button margin'}
          onClick={onRefresh}
          style={{
            minWidth: '100px',
          }}
        >
          {isRefreshing ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Refresh'}
        </Button>
      </Grid>
      <Grid item xs={4}>
        <div
          onMouseEnter={onPopoverOpen}
          onMouseLeave={onPopoverClose}
          style={{ display: 'inline-block' }}
        >
          <Button
            disabled={isImporting || isLoading || !glCompanyId || noShopCheckboxEnabled}
            className={'primary-button margin'}
            style={{
              minWidth: '100px',
            }}
            onClick={openImportModal}
          >
            {isImporting ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Import'}
          </Button>
        </div>
        <Popover
          id="mouse-over-popover"
          style={{ pointerEvents: 'none' }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={onPopoverClose}
          disableRestoreFocus
        >
          <Typography style={{ padding: '8px 16px' }}>Data has already been imported</Typography>
        </Popover>
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/MigrationActions.tsx